import { createRoute } from '@tanstack/react-router'
import { t } from 'i18next'

import { DynamicRouteParameterWPrefix } from 'config/routing'
import { Overview } from 'domains/MediaPlatforms/Offers/Offer'
import { mediaPlatformOffersRoute } from 'pages/NWPlatform/MediaPlatforms/MediaPlatform/Offers'
import { Structure } from 'pages/NWPlatform/MediaPlatforms/MediaPlatform/Offers/Offer'

export const mediaPlatformOfferRoute = createRoute({
  getParentRoute: () => mediaPlatformOffersRoute,
  path: DynamicRouteParameterWPrefix.OFFER_ID,
  loader: () => ({
    crumb: t('entity:publishing.offer', { count: 1 }),
  }),
})

export const mediaPlatformOfferLayoutRoute = createRoute({
  getParentRoute: () => mediaPlatformOfferRoute,
  id: 'mediaPlatformOfferLayout',
  component: Structure,
})

export const mediaPlatformOfferRawRoute = createRoute({
  getParentRoute: () => mediaPlatformOfferLayoutRoute,
  path: '/',
  component: Overview,
})
